export const MENU_ITEM_TYPE = {
  IMAGE: 'image',
  TEXT: 'text',
} as const;

export type MENU_ITEM_TYPE_KEY = keyof typeof MENU_ITEM_TYPE;
export type MENU_ITEM_TYPE_VALUE = typeof MENU_ITEM_TYPE[MENU_ITEM_TYPE_KEY];

export const MENU_ITEM_TYPE_MAP = {
  [MENU_ITEM_TYPE.IMAGE]: '이미지형',
  [MENU_ITEM_TYPE.TEXT]: '텍스트형',
};

export const menuItemList = Object.keys(MENU_ITEM_TYPE_MAP).map((key) => {
  return {
    key: key,
    value: MENU_ITEM_TYPE_MAP[key],
  };
});
